module.exports = __webpack_public_path__ + "9bd5b60ad6a68ba06ae2f7c2edc0601b.svg";